module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Italic.84858e2a.woff2";